import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { ConcretePlacement } from '../../types'
import FirstTable from './components/FirstTable'
import SecondTable from './components/SecondTable'
import ThirdTable from './components/ThirdTable'

export function useExpand(
  cureRate: number | null
): ExpandOptions<ConcretePlacement> {
  return {
    render: (record) => ({
      custom: [
        { children: <FirstTable {...record} /> },
        {
          children: (
            <SecondTable concretePlacement={record} cureRate={cureRate} />
          ),
        },
        { children: <ThirdTable {...record} /> },
      ],
    }),
  }
}
